import Icon, { IconType } from 'components/Icon';
import { useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import * as S from './styles';

interface FeedbackBarProps {
	feedback: 'helpful' | 'not_helpful' | null | undefined;
	isLastEntry: boolean;
	isGenerating: boolean;
	onCopy: () => void;
	onFeedback: (feedback: 'helpful' | 'not_helpful') => void;
}

const FeedbackBar = ({
	feedback,
	isLastEntry,
	isGenerating,
	onCopy,
	onFeedback,
}: FeedbackBarProps) => {
	const theme = useTheme();
	const [isCopied, setIsCopied] = useState(false);
	const copyTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	useEffect(() => {
		return () => {
			if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
		};
	}, []);

	if (isGenerating) return null;

	const onCopyClick = () => {
		onCopy();
		setIsCopied(true);
		if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
		copyTimerRef.current = setTimeout(() => setIsCopied(false), 1500);
	};

	return (
		<S.Base hasSelection={!!feedback} alwaysShow={isLastEntry}>
			<S.Button isActive={isCopied} onClick={onCopyClick}>
				<Icon
					type={isCopied ? IconType.CHECK : IconType.COPY}
					width={14}
					height={14}
					color={isCopied ? theme.gray[900] : theme.gray[600]}
				/>
			</S.Button>
			{(!feedback || feedback === 'helpful') && (
				<S.Button isActive={feedback === 'helpful'} onClick={() => onFeedback('helpful')}>
					<Icon
						type={IconType.THUMBS_UP}
						width={14}
						height={14}
						color={feedback === 'helpful' ? theme.gray[900] : theme.gray[600]}
					/>
				</S.Button>
			)}
			{(!feedback || feedback === 'not_helpful') && (
				<S.Button isActive={feedback === 'not_helpful'} onClick={() => onFeedback('not_helpful')}>
					<Icon
						type={IconType.THUMBS_DOWN}
						width={14}
						height={14}
						color={feedback === 'not_helpful' ? theme.gray[900] : theme.gray[600]}
					/>
				</S.Button>
			)}
		</S.Base>
	);
};

export default FeedbackBar;
